(function () {
  var config = document.getElementById('cart-drawer');
  if (!config) return;
  var eligibleIds = new Set((config.dataset.sleeveVariants || '').split(',').filter(Boolean));
  var includedNote = 'Travel Sleeve is included in the glasses package. Do not order an extra sleeve.';
  var sleeveId = Number(config.dataset.sleeveId);
  var queue = Promise.resolve();
  function enqueue(work) {
    var result = queue.catch(function () {}).then(work);
    queue = result;
    return result;
  }
  function propertiesFor(properties) {
    return Object.assign({}, properties || {}, {
      'Travel Sleeve': 'Included',
      '_skopos_included_in_package': includedNote
    });
  }
  function decorate(items) {
    return items.map(function (item) {
      return eligibleIds.has(String(item.id))
        ? Object.assign({}, item, { properties: propertiesFor(item.properties) })
        : item;
    });
  }
  async function request(path, payload) {
    var root = window.Shopify?.routes?.root || '/';
    var options = { headers: { 'Accept': 'application/json' }, cache: 'no-store' };
    if (payload) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(payload);
    }
    var response = await fetch(root.replace(/\/$/, '') + '/' + path.replace(/^\//, ''), options);
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your cart. Please try again.');
    return result;
  }
  async function normalize(cart) {
    for (var pass = 0; pass < 64; pass++) {
      var item = cart.items.find(function (line) {
        return eligibleIds.has(String(line.variant_id)) &&
          (line.properties?.['Travel Sleeve'] !== 'Included' || line.properties?._skopos_included_in_package !== includedNote);
      });
      if (!item) {
        var managedSleeve = cart.items.find(function(line) {
          return Number(line.variant_id) === sleeveId && line.properties?._skopos_package_component === 'sleeve';
        });
        if (managedSleeve) {
          cart = await request('cart/change.js', {id: managedSleeve.key, quantity: 0});
          continue;
        }
        if (window.SkoposReward) window.SkoposReward.update(cart);
        return cart;
      }
      cart = await request('cart/change.js', { id: item.key, quantity: item.quantity, properties: propertiesFor(item.properties) });
    }
    throw new Error('Unable to update your cart. Please try again.');
  }
  window.SkoposIncludedSleeve = {
    decorate: decorate,
    refresh: function () { return enqueue(async function () { return normalize(await request('cart.js')); }); },
    update: function (path, payload) {
      return enqueue(async function () {
        if (path.replace(/^\//, '') === 'cart/add.js') payload = Object.assign({}, payload, { items: decorate(payload.items) });
        await request(path, payload);
        return normalize(await request('cart.js'));
      });
    }
  };
})();
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var bodyEl = drawer.querySelector('.cart-drawer__body');
  var footerEl = drawer.querySelector('.cart-drawer__footer');
  var countEl = drawer.querySelector('.cart-drawer__count');
  var totalEl = drawer.querySelector('.cart-drawer__total-value');
  var shippingEl = drawer.querySelector('.cart-drawer__shipping');
  var shippingFill = drawer.querySelector('.cart-drawer__shipping-fill');
  var shippingLabel = drawer.querySelector('.cart-drawer__shipping-label');
  var upsellRow = drawer.querySelector('.cart-drawer__upsell-row');

  var moneyFormat = drawer.getAttribute('data-money-format') || '';
  var emptyText = drawer.getAttribute('data-empty-text') || '';
  var emptyCtaLabel = drawer.getAttribute('data-empty-cta-label') || '';
  var emptyCtaLink = drawer.getAttribute('data-empty-cta-link') || '/';
  var itemTagline = drawer.getAttribute('data-item-tagline') || '';
  var removeLabel = drawer.getAttribute('data-remove-label') || 'Remove';

  // Parse multi-threshold config
  var rawThresholds = (drawer.getAttribute('data-thresholds') || '').split(',');
  var rawProgress = (drawer.getAttribute('data-progress-texts') || '').split(',');
  var rawUnlocked = (drawer.getAttribute('data-unlocked-texts') || '').split(',');

  var thresholds = [];
  for (var ti = 0; ti < 3; ti++) {
    var val = parseFloat(rawThresholds[ti]) || 0;
    if (val > 0) {
      thresholds.push({
        cents: val * 100,
        progress: rawProgress[ti] || '',
        unlocked: rawUnlocked[ti] || '',
        milestoneEl: drawer.querySelector('[data-milestone="' + (ti + 1) + '"]')
      });
    }
  }

  var CHECK_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6.3l2.3 2.4 4.7-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var lastTrigger = null;
  var busy = false;

  function formatMoney(cents, withoutTrailingZeros) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(n, p, t, d) {
      p = p == null ? 2 : p; t = t || ','; d = d || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return dollars + (parts[1] ? d + parts[1] : '');
    }
    var match = moneyFormat.match(placeholder);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    if (withoutTrailingZeros) value = value.replace(/[.,]00$/, '');
    return match ? moneyFormat.replace(placeholder, value) : value;
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function sizedImage(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=144';
  }

  function emptyHtml() {
    return '<div class="cart-drawer__empty">' +
      '<p class="cart-drawer__empty-text">' + escapeHtml(emptyText) + '</p>' +
      '<a class="cart-drawer__button cart-drawer__button--shop" href="' + escapeHtml(emptyCtaLink) + '">' + escapeHtml(emptyCtaLabel) + '</a>' +
      '</div>';
  }

  function itemProperties(item) {
    if (!item.properties) return '';
    var parts = [];
    var kitIncluded = false;
    Object.keys(item.properties).forEach(function(key) {
      if (key.charAt(0) === '_') return;
      var val = item.properties[key];
      if (key === 'Travel Sleeve' && val === 'Included') { kitIncluded = true; return; }
      if (val === null || val === undefined || val === '') return;
      parts.push(escapeHtml(String(val)));
    });
    return (kitIncluded ? '<p class="cart-drawer__kit-note">' + escapeHtml(drawer.dataset.kitLabel) + '</p>' : '') +
      (parts.length ? '<p class="cart-drawer__item-desc">' + parts.join(' · ') + '</p>' : '');
  }

  var TAG_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 8.6V3.2c0-.4.3-.7.7-.7h5.4l5 5a1 1 0 0 1 0 1.4l-4.3 4.3a1 1 0 0 1-1.4 0z"/><circle cx="5.5" cy="5.5" r="1"/></svg>';
  function plainMoney(cents) { return formatMoney(cents, true).replace(/<[^>]*>/g, ''); }
  function discountTags(list) {
    var tags = list.filter(function (d) { return d.title && Number(d.amount) > 0; }).map(function (d) {
      return '<span class="skc-tag">' + TAG_SVG + escapeHtml(d.title) + ' (\u2212' + escapeHtml(plainMoney(d.amount)) + ')</span>';
    }).join('');
    return tags ? '<div class="skc-tags">' + tags + '</div>' : '';
  }

  function itemRow(item) {
    var isSleeve = item.properties?._skopos_package_component === 'sleeve';
    var price = Math.max(0, item.original_line_price - (item.total_discount || 0));
    var priceHtml = (price === 0 ? '<strong class="skc-free">' + escapeHtml(drawer.dataset.freeLabel) + '</strong>' : '<span>' + formatMoney(price, true) + '</span>') +
      (item.original_line_price > price ? ' <s>' + formatMoney(item.original_line_price, true) + '</s>' : '');
    var tagsHtml = discountTags((item.line_level_discount_allocations || []).map(function (a) { return { title: a.discount_application && a.discount_application.title, amount: a.amount }; }));
    var img = sizedImage(item.image);
    var imgTag = img
      ? '<img class="cart-drawer__item-image" src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">'
      : '<span class="cart-drawer__item-image"></span>';
    var tagline = itemTagline ? '<p class="cart-drawer__item-tagline">' + escapeHtml(itemTagline) + '</p>' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
    return '<li class="cart-drawer__item" data-line-key="' + escapeHtml(item.key) + '">' +
      '<a class="cart-drawer__item-image-link" href="' + escapeHtml(item.url) + '">' + imgTag + '</a>' +
      '<div class="cart-drawer__item-main">' +
        (isSleeve ? '' : '<button type="button" class="cart-drawer__remove" data-qty-action="remove">' + escapeHtml(removeLabel) + '</button>') +
        '<a class="cart-drawer__item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
        variant + itemProperties(item) +
        '<span class="cart-drawer__item-price">' + priceHtml + '</span>' + tagsHtml +
        (isSleeve ? '' : '<div class="cart-drawer__qty">' +
          '<button type="button" class="cart-drawer__qty-btn" data-qty-action="decrease" aria-label="Decrease"' + (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
          '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
          '<button type="button" class="cart-drawer__qty-btn" data-qty-action="increase" aria-label="Increase">+</button>' +
        '</div>') +
      '</div>' +
    '</li>';
  }

  function renderShipping(totalPrice) {
    if (!thresholds.length) return;

    // Find the active (next unpassed) threshold
    var activeIdx = -1;
    for (var i = 0; i < thresholds.length; i++) {
      thresholds[i].milestoneEl && thresholds[i].milestoneEl.classList.toggle('is-unlocked', totalPrice >= thresholds[i].cents);
      if (activeIdx === -1 && totalPrice < thresholds[i].cents) activeIdx = i;
    }

    // Determine progress bar range
    var prevCents = activeIdx > 0 ? thresholds[activeIdx - 1].cents : 0;
    var nextCents = activeIdx > -1 ? thresholds[activeIdx].cents : thresholds[thresholds.length - 1].cents;
    var pct;
    if (activeIdx === -1) {
      pct = 100;
    } else {
      pct = Math.min(100, ((totalPrice - prevCents) / (nextCents - prevCents)) * 100);
    }
    shippingFill.style.width = pct + '%';

    if (activeIdx === -1) {
      // All thresholds passed — show last unlocked message
      var last = thresholds[thresholds.length - 1];
      shippingLabel.classList.add('is-unlocked');
      shippingLabel.innerHTML = CHECK_SVG + '<span>' + escapeHtml(last.unlocked) + '</span>';
    } else {
      var active = thresholds[activeIdx];
      var remaining = active.cents - totalPrice;
      var msg = active.progress.replace('[remaining]', formatMoney(remaining));
      shippingLabel.classList.remove('is-unlocked');
      shippingLabel.innerHTML = '<span>' + escapeHtml(msg) + '</span>';
    }
  }

  function updateCount(count) {
    var headerBadge = document.querySelector('[data-cart-count]');
    if (headerBadge) { headerBadge.textContent = count; headerBadge.hidden = count === 0; }
    if (countEl) { countEl.textContent = count; countEl.hidden = count === 0; }
  }

  var rewardRequest=0;
  async function refreshRewards(){
    var request=++rewardRequest;
    try{var response=await fetch(cartUrl('/?section_id=skopos-cart-rewards'),{cache:'no-store'});if(!response.ok)return;var doc=new DOMParser().parseFromString(await response.text(),'text/html');var rewards=doc.querySelector('[data-rewards]');var target=drawer.querySelector('[data-drawer-rewards]');if(request===rewardRequest && target && rewards){target.replaceChildren(rewards);target.classList.remove('is-stale');} }catch(error){}
  }
  function render(cart) {
    if (window.SkoposReward) window.SkoposReward.update(cart);
    var empty = cart.item_count === 0;
    var oldRewards = bodyEl.querySelector('[data-drawer-rewards]');
    var keepRewards = oldRewards ? Array.prototype.slice.call(oldRewards.childNodes) : [];
    if (empty) {
      bodyEl.innerHTML = '<div data-drawer-rewards></div>'+emptyHtml();
    } else {
      bodyEl.innerHTML = '<div data-drawer-rewards></div><ul class="cart-drawer__items" role="list">' + cart.items.slice().sort(function(a,b){return Number(a.properties?._skopos_package_component === 'sleeve')-Number(b.properties?._skopos_package_component === 'sleeve');}).map(itemRow).join('') + '</ul>';
      var saved = cart.original_total_price - cart.total_price;
      totalEl.innerHTML = (saved > 0 ? '<span class="skc-save">' + escapeHtml(drawer.dataset.savingsLabel.replace('[amount]', plainMoney(saved))) + '</span>' : '') +
        '<strong>' + formatMoney(cart.total_price, true) + '</strong>' +
        (saved > 0 ? '<s>' + formatMoney(cart.original_total_price, true) + '</s>' : '');
      var orderDiscounts = drawer.querySelector('.cart-drawer__discounts');
      if (orderDiscounts) orderDiscounts.innerHTML = discountTags((cart.cart_level_discount_applications || []).map(function (d) { return { title: d.title, amount: d.total_allocated_amount }; })).replace(/^<div class="skc-tags">|<\/div>$/g, '');
      var savings = drawer.querySelector('[data-cart-savings]');
      savings.hidden = true;
      savings.textContent = drawer.dataset.savingsLabel.replace('[amount]', formatMoney(cart.original_total_price - cart.total_price, true).replace(/<[^>]*>/g, ''));
      if (thresholds.length) {
        shippingEl.hidden = false;
        renderShipping(cart.total_price);
      }
    }
    var newRewards = bodyEl.querySelector('[data-drawer-rewards]');
    if (newRewards && keepRewards.length) { keepRewards.forEach(function (node) { newRewards.appendChild(node); }); newRewards.classList.add('is-stale'); }
    footerEl.hidden = empty;
    if (!thresholds.length) shippingEl.hidden = true;
    if (empty) shippingEl.hidden = true;
    updateCount(cart.item_count);
    refreshRewards();
    var upsell=drawer.querySelector('.cart-drawer__upsell');if(upsell)upsell.hidden=true;
  }

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function fetchCart() {
    if (window.SkoposIncludedSleeve) return window.SkoposIncludedSleeve.refresh();
    return fetch(cartUrl('/cart.js'), { headers: { 'Accept': 'application/json' } }).then(function(r) {
      if (!r.ok) throw new Error('Could not load cart');
      return r.json();
    });
  }


  var errorEl = drawer.querySelector('.cart-drawer__error');
  var previousOverflow = '';
  function setBusy(value) {
    busy=value; drawer.classList.toggle('is-busy',value); drawer.setAttribute('aria-busy',String(value));
    drawer.querySelectorAll('[data-upsell-add], [data-qty-action], [data-reward-add], [name="checkout"]').forEach(function(button) {
      if(value) { button.dataset.wasDisabled=String(button.disabled); button.disabled=true; }
      else { button.disabled=button.dataset.wasDisabled==='true' || (button.dataset.qtyAction==='decrease' && Number(button.closest('[data-line-key]').querySelector('.cart-drawer__qty-value').textContent)<=1); delete button.dataset.wasDisabled; }
    });
  }
  function showError(error) { errorEl.textContent=error.message || 'Unable to update cart. Please try again.';errorEl.hidden=false; }
  function showDrawer() {
    if(!drawer.open) { lastTrigger=document.activeElement;previousOverflow=document.body.style.overflow;drawer.showModal();document.body.style.overflow='hidden'; }
    drawer.classList.add('is-open');
  }
  async function openDrawer() {
    showDrawer();errorEl.hidden=true;
    try { render(await fetchCart()); } catch(error) { showError(error); }
  }
  function closeDrawer() { drawer.close(); }
  drawer.addEventListener('close',function(){ drawer.classList.remove('is-open');document.body.style.overflow=previousOverflow;if(lastTrigger && lastTrigger.isConnected) lastTrigger.focus(); });
  async function mutate(path,payload) {
    if(busy) throw new Error('Please wait for your cart to finish updating.');
    setBusy(true);errorEl.hidden=true;
    try {
      var cart=await window.SkoposIncludedSleeve.update(path,payload);
      showDrawer();
      try { render(cart);document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart})); }
      catch(error) { showError(new Error('Your item was added. Reopen the cart to refresh its contents.')); }
    } finally { setBusy(false); }
  }
  window.SkoposCart={open:openDrawer,add:function(items){return mutate('/cart/add.js',{items:items});}};
  document.addEventListener('submit',async function(event){
    if (!event.target.matches('[data-skopos-checkout]')) return;
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    if (event.target.dataset.preparingCheckout === 'true') return;
    event.target.dataset.preparingCheckout = 'true';
    var checkoutButton = event.submitter;
    checkoutButton.disabled = true;
    try {
      var cart = await fetchCart();
      if (!cart.item_count) { render(cart); return; }
      window.location.assign(cartUrl('/checkout'));
    } catch(failure) {
      if(drawer.open) showError(failure);
      else {
        var pageError=document.querySelector('.scp-error');
        if(pageError){pageError.textContent=failure.message;pageError.hidden=false;}
      }
    } finally {
      delete event.target.dataset.preparingCheckout;
      checkoutButton.disabled = false;
    }
  });
  document.addEventListener('click',function(e){
    var trigger=e.target.closest('a[href], [data-cart-trigger]');
    if(trigger && !drawer.contains(trigger) && (trigger.hasAttribute('data-cart-trigger') || new URL(trigger.href,location.href).pathname===cartUrl('/cart'))) {
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();openDrawer();return;
    }
    if(e.target.closest('[data-cart-close]')) { closeDrawer();return; }
    if(e.target.closest('[data-upsell-prev]') && upsellRow) { upsellRow.scrollBy({left:-212,behavior:'smooth'});return; }
    if(e.target.closest('[data-upsell-next]') && upsellRow) { upsellRow.scrollBy({left:212,behavior:'smooth'});return; }
    var skrArrow=e.target.closest('[data-skr-prev],[data-skr-next]');
    if(skrArrow && drawer.contains(skrArrow)){var skrRow=skrArrow.closest('.skr-upsell').querySelector('[data-skr-row]');var skrCard=skrRow&&skrRow.querySelector('.skr-card');if(skrRow)skrRow.scrollBy({left:(skrArrow.hasAttribute('data-skr-prev')?-1:1)*((skrCard?skrCard.getBoundingClientRect().width:240)+8),behavior:'smooth'});return;}
    if(busy) return;
    var reward=e.target.closest('[data-reward-add]');
    if(reward && drawer.contains(reward)){var picker=reward.closest('[data-rewards]').querySelector('[data-reward-picker]');var rewardId=Number(reward.dataset.variantId||(picker&&picker.value)||0);if(rewardId)mutate('/cart/add.js',{items:[{id:rewardId,quantity:1}]}).catch(showError);return;}
    var add=e.target.closest('[data-upsell-add]');
    if(add && drawer.contains(add)) { mutate('/cart/add.js',{items:[{id:Number(add.dataset.variantId),quantity:1}]}).catch(showError);return; }
    var qty=e.target.closest('[data-qty-action]');
    if(qty && drawer.contains(qty)) {
      var row=qty.closest('[data-line-key]');var value=Number(row.querySelector('.cart-drawer__qty-value').textContent);
      var action=qty.dataset.qtyAction;var next=action==='remove'?0:value+(action==='increase'?1:-1);
      mutate('/cart/change.js',{id:row.dataset.lineKey,quantity:Math.max(0,next)}).catch(showError);
    }
  });
  document.addEventListener('skopos:reward-applied',function(event){render(event.detail);});
  document.addEventListener('cart-drawer:open',openDrawer);
  document.addEventListener('cart:refresh',function(){fetchCart().then(render).catch(showError);});
  fetchCart().then(function(cart){render(cart);document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));}).catch(function(){});
})();
